// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"bc1ba83c","455":"76abb6a4","512":"bdb41c84","585":"36028334","735":"b7e7118a","836":"bd33c736","840":"661274bd","857":"eddcdb81","885":"fc9c31ce","890":"3695551e","977":"86d65106"}[chunkId] + ".chunk.js";
};